import core from 'Core/core';

function importAll(r) {
  r.keys().forEach(r);
}

importAll(
  import.meta.webpackContext("../../materials/components/", {
    recursive: true,
    regExp: /\.js$/,
  }),
);

importAll(
  import.meta.webpackContext("../../materials/containers/", {
    recursive: true,
    regExp: /\.js$/,
  }),
);

core();
